
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as voteO897vqA6SdnvBiHxTVBVEZDzn6FRJ_QiU21bkLX5JSgMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/vote.vue?macro=true";
import { default as indexlhclFo8DKaZQ4vfMeBZVf6otlzcbdZqAoDxdOTsaZggMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/index.vue?macro=true";
import { default as onboardLL4XM0xNmoV9wIax7vLjPF0YwlHm2jFlA524X4Mq9tEMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/onboard.vue?macro=true";
import { default as _91id_93aqPJeOv5qhtY3zlHGmgtg9hcp6GJQWh8ddnU3qs0alIMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/blog/[id].vue?macro=true";
import { default as indexJyjcj_457CR2hA_45WLnXhCLoEX0lNSQlid4GIApvnrpDZwMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/blog/index.vue?macro=true";
import { default as index_cY6IWsID1TB3i2AwRpKwt9NhU0Sblv_453gXtjLE_45qG8Meta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/account/index.vue?macro=true";
import { default as ordersyQ6UX2Jy_3R3KzxDrY9VCzf1rKsuIxdQKcE00aPFZJcMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/account/orders.vue?macro=true";
import { default as privacy_45policyjnTgfWUb_NhbL1Kzgv0jaC_45wXBIJ8yfWKSrW2PbbyEUMeta } from "/home/runner/work/web-app/web-app/apps/homepage/pages/privacy-policy.vue?macro=true";
import { default as component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta } from "/home/runner/work/web-app/web-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ } from "/home/runner/work/web-app/web-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "vote___en",
    path: "/vote",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/vote.vue")
  },
  {
    name: "vote___cs",
    path: "/cs/vote",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/vote.vue")
  },
  {
    name: "vote___fr",
    path: "/fr/vote",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/vote.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/index.vue")
  },
  {
    name: "onboard___en",
    path: "/onboard",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/onboard.vue")
  },
  {
    name: "onboard___cs",
    path: "/cs/onboard",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/onboard.vue")
  },
  {
    name: "onboard___fr",
    path: "/fr/onboard",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/onboard.vue")
  },
  {
    name: "blog-id___en",
    path: "/blog/:id()",
    meta: _91id_93aqPJeOv5qhtY3zlHGmgtg9hcp6GJQWh8ddnU3qs0alIMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/[id].vue")
  },
  {
    name: "blog-id___cs",
    path: "/cs/blog/:id()",
    meta: _91id_93aqPJeOv5qhtY3zlHGmgtg9hcp6GJQWh8ddnU3qs0alIMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/[id].vue")
  },
  {
    name: "blog-id___fr",
    path: "/fr/blog/:id()",
    meta: _91id_93aqPJeOv5qhtY3zlHGmgtg9hcp6GJQWh8ddnU3qs0alIMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/[id].vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/index.vue")
  },
  {
    name: "blog___cs",
    path: "/cs/blog",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/blog/index.vue")
  },
  {
    name: "account___en",
    path: "/account",
    meta: index_cY6IWsID1TB3i2AwRpKwt9NhU0Sblv_453gXtjLE_45qG8Meta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/index.vue")
  },
  {
    name: "account___cs",
    path: "/cs/account",
    meta: index_cY6IWsID1TB3i2AwRpKwt9NhU0Sblv_453gXtjLE_45qG8Meta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: index_cY6IWsID1TB3i2AwRpKwt9NhU0Sblv_453gXtjLE_45qG8Meta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/index.vue")
  },
  {
    name: "account-orders___en",
    path: "/account/orders",
    meta: ordersyQ6UX2Jy_3R3KzxDrY9VCzf1rKsuIxdQKcE00aPFZJcMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/orders.vue")
  },
  {
    name: "account-orders___cs",
    path: "/cs/account/orders",
    meta: ordersyQ6UX2Jy_3R3KzxDrY9VCzf1rKsuIxdQKcE00aPFZJcMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/orders.vue")
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: ordersyQ6UX2Jy_3R3KzxDrY9VCzf1rKsuIxdQKcE00aPFZJcMeta || {},
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/account/orders.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___cs",
    path: "/cs/privacy-policy",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/home/runner/work/web-app/web-app/apps/homepage/pages/privacy-policy.vue")
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/qr1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/cs/qr1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/fr/qr1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/qr/1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/cs/qr/1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  },
  {
    name: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQMeta?.name,
    path: "/fr/qr/1",
    component: component_45stubr9WoxDJQ4ukJYCWMa3GeM3OlMjA18xthm1zM0amGfzQ
  }
]